import httpRequest, { getRequestConfig } from '@/utils/request';

const todoUrl = '/Todo';
const todoUrlForRemind = `${todoUrl}/remind`;

const generateUrlByTodoId = (todoId: string): string => {
  return `/Todo/${todoId}`;
};
const batchCreateTodoUrl = '/Todo/batch/add';

const todoStatusUrl = (todoId: string): string => {
  return `/Todo/${todoId}/status`;
};

const checkInTodoUrl = (todoId: string): string => {
  return `/Todo/${todoId}/in`;
};
const checkOutTodoUrl = (todoId: string): string => {
  return `/Todo/${todoId}/out`;
};

const updateCommentUrl = (todoId: string): string => {
  return `${todoUrl}/${todoId}/comment`;
};
const getCurrentGrabTodoListUrl = 'Todo/getCurrentGrabTodoList';
const getGrabTodoListUrl = 'Todo/getGrabTodoList';
const setOwnerUrl = 'Todo/setOwner';
const rejectOwnerUrl = 'Todo/rejectTodoOwner';

export const searchTodo = (
  params: ITodo.IRequest.ISearchTodo,
): Promise<ITodo.IResponse.IData> => {
  return httpRequest.get(todoUrl, {
    params,
  });
};

export const createTodo = (
  params: ITodo.IRequest.ICreateTodo,
): Promise<IResponseData.IBaseData> => {
  const url = generateUrlByTodoId(params.todoId);
  return httpRequest.post(url, params.data);
};
export const batchUpdateTodo = (
  params: ITodo.IRequest.IBatchUpdateTodoParams[],
): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(`${todoUrl}/batch/update`, params);
};
export const batchCreateTodo = (
  params: ITodo.IRequest.IBatchCreateTodoParams[],
): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(batchCreateTodoUrl, params);
};

export const completeTodo = (todoId: string): Promise<IResponseData.IBaseData> => {
  const url = todoStatusUrl(todoId);
  return httpRequest.put(url, null, {
    params: {
      status: 'Completed',
    },
  });
};
export const reviewTodo = (todoId: string): Promise<IResponseData.IBaseData> => {
  const url = todoStatusUrl(todoId);
  return httpRequest.put(url, null, {
    params: {
      status: 'Reviewed',
    },
  });
};
export const closelTodo = (todoId: string): Promise<IResponseData.IBaseData> => {
  const url = todoStatusUrl(todoId);
  return httpRequest.put(url, null, {
    params: {
      status: 'Closed',
    },
  });
};

export const checkInTodo = (todoId: string): Promise<IResponseData.IBaseData> => {
  const url = checkInTodoUrl(todoId);
  return httpRequest.post(url);
};
export const checkOutTodo = (todoId: string): Promise<IResponseData.IBaseData> => {
  const url = checkOutTodoUrl(todoId);
  return httpRequest.post(url);
};

export const deleteTodo = (todoId: string): Promise<IResponseData.IBaseData> => {
  const url = generateUrlByTodoId(todoId);
  return httpRequest.delete(url);
};
export const getTodoListForRemind = (): Promise<ITodo.IResponse.IRemindData> => {
  return httpRequest.get(todoUrlForRemind);
};
export const undoTodo = (todoId: string): Promise<IResponseData.IBaseData> => {
  const url = generateUrlByTodoId(todoId);
  return httpRequest.post(`${url}/undo`);
};


// todo type api

const todoTypeUrl = `/TodoType`;
const updateTodoTypeUrl = (todoTypeId: string): string => {
  return `${todoTypeUrl}/${todoTypeId}`;
};
export const getTodoTypes = (params: ITodo.IRequest.IGetTodoType = {}): Promise<ITodo.IResponse.ITypeData> => {
  return httpRequest.get(todoTypeUrl, {
    params,
  });
};

export const updateTodoType = (params: ITodo.IRequest.IUpdateTodoType): Promise<IResponseData.IBaseData> => {
  const url = updateTodoTypeUrl(params.id);
  return httpRequest.post(url, params.data);
};
export const deleteTodoType = (todoTypeId: string): Promise<IResponseData.IBaseData> => {
  const url = updateTodoTypeUrl(todoTypeId);
  return httpRequest.delete(url);
};

export const updateComment = (
  params: ITodo.IRequest.IUpdateComment,
): Promise<IResponseData.IBaseData> => {
  const url = updateCommentUrl(params.todoId);
  return httpRequest.post(url, params.data);
};
export const generateUploadConfig = (): {url: string, headers: object} => {
  const {baseURL, headers} = getRequestConfig();
  return {
    url: `${baseURL}${todoTypeUrl}/import`,
    headers,
  };
};

/* 抢单数据接口 */
// 获取当前登录人可抢单的todo list
export const getCurrentGrabTodoList = (): Promise<ITodo.IResponse.IGrabTodoListData> => {
  return httpRequest.get(getCurrentGrabTodoListUrl);
};
// 获取当前登录人已发布的抢单任务
export const getGrabTodoList = (): Promise<ITodo.IResponse.IGrabTodoListData> => {
  return httpRequest.get(getGrabTodoListUrl);
};
// 接受、同意抢单跟进人
export const setOwner = (params: ITodo.IRequest.ISetGrabTodoOwner): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(setOwnerUrl, params);
};
// 拒绝抢单跟进人
export const rejectOwner = (params: ITodo.IRequest.IRejectGrabTodoOwner): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(rejectOwnerUrl, params);
};
